import { render, staticRenderFns } from "./ClientFooter.vue?vue&type=template&id=4d26b386&scoped=true&"
import script from "./ClientFooter.vue?vue&type=script&lang=js&"
export * from "./ClientFooter.vue?vue&type=script&lang=js&"
import style0 from "./ClientFooter.vue?vue&type=style&index=0&id=4d26b386&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d26b386",
  null
  
)

export default component.exports